<!-- 此 component 用來 Edit 檔案頁面 -->
<template>
	<section style="margin: 0px auto;">
		<el-col :span="12" class="edit-table" v-show="show">
			<el-form :inline="false">
				<el-form-item class="edit-row">
					<div class="edit-name">姓名</div>
					<input v-if="$store.state.accountList.status === 3" class="edit-input" 
					       v-model="$store.state.editAccount.displayName" 
								 placeholder="請輸入會員姓名" 
								 v-on:keydown.enter.prevent='prevent'
								 disabled>
					<input v-else class="edit-input" 
					       v-model="$store.state.editAccount.displayName" 
								 placeholder="請輸入會員姓名" 
								 v-on:keydown.enter.prevent='prevent'>
					<span v-show="$store.state.accountList.status === 2" style="color: red; margin-left: 5px; font-size: 14px;">*</span>
				</el-form-item>
			</el-form>
			<el-form :inline="false">
				<el-form-item class="edit-row">
					<div class="edit-name">帳號</div>
					<input v-if="$store.state.accountList.status === 3" class="edit-input" 
					       v-model="$store.state.editAccount.name" 
								 placeholder="請輸入會員帳號" 
								 v-on:keydown.enter.prevent='prevent'
								 disabled>
					<input v-else class="edit-input" 
					       v-model="$store.state.editAccount.name" 
								 placeholder="請輸入會員帳號" 
								 v-on:keydown.enter.prevent='prevent'>
					<span v-show="$store.state.accountList.status === 2" style="color: red; margin-left: 5px; font-size: 14px;">*</span>
				</el-form-item>
			</el-form>
			<el-form :inline="false">
				<el-form-item class="edit-row">
					<div class="edit-name">信箱</div>
					<input v-if="$store.state.accountList.status === 3" class="edit-input" 
					       v-model="$store.state.editAccount.email" 
								 placeholder="請輸入會員信箱" 
								 v-on:keydown.enter.prevent='prevent'
								 disabled>
					<input v-else class="edit-input" 
					       v-model="$store.state.editAccount.email" 
								 placeholder="請輸入會員信箱" 
								 v-on:keydown.enter.prevent='prevent'>
					<span v-show="$store.state.accountList.status === 2" style="color: red; margin-left: 5px; font-size: 14px;">*</span>
				</el-form-item>
			</el-form>
			<el-form :inline="false">
				<el-form-item class="edit-row">
					<div class="edit-name">密碼</div>
					<el-button v-if="!isResetPW" class="reset-btn" @click="resetPassword(true)">重設密碼</el-button>
					<div v-else>
						<div style="width: 100% ; display: block ; position: relative">
							<input class="edit-input"
										:type="showPass ? 'text' : 'password'"  
										v-model="$store.state.editAccount.password" 
										placeholder="請輸入密碼" 
										autocomplete="off"
										v-on:keydown.enter.prevent='prevent'>
							<img :title="showPass? '顯示密碼': '隱藏密碼'" 
												@click="showPass=!showPass" 
												style="position: absolute; width: 20px; height: 20px; margin-top: 8px; margin-left: -30px; cursor: pointer;"
												:src="showPass?openeye:nopeneye">
							<span style="color: red; margin-left: 5px; font-size: 14px;">*</span>
						</div>
						<div style="width: 100% ; margin: 10px 32px; display: block ; position: relative">
							<input class="edit-input" 
										:type="showPass2 ? 'text' : 'password'" 
										v-model="$store.state.editAccount.checkPassword" 
										autocomplete="off"
										placeholder="再次輸入密碼" 
										v-on:keydown.enter.prevent='prevent'>
							<img :title="showPass2? '顯示密碼': '隱藏密碼'" 
												@click="showPass2=!showPass2" 
												style="position: absolute; width: 20px; height: 20px; margin-top: 8px; margin-left: -30px; cursor: pointer;"
												:src="showPass2?openeye:nopeneye">
							<span style="color: red; margin-left: 5px; font-size: 14px;">*</span>
						</div>
					</div>
				</el-form-item>
			</el-form>
			<el-form v-show="this.$store.state.isSystemAdminMode" :inline="false">
				<el-form-item class="edit-row">
					<div class="edit-name">部門</div>
					<el-cascader class="filter-select" placeholder=""
								v-model="filter.actualDeps.selected" :show-all-levels="false"
    							:options="filter.actualDeps.options" @change="actualDepsSelect">
					</el-cascader>
				</el-form-item>
			</el-form>
			<el-form :inline="false">
				<el-form-item class="edit-row">
					<div class="edit-name">權限</div>
					<el-select v-model="filter.level.selected" 
					           placeholder="" 
										 class="filter-select" 
										 @change="levelSelect">
						<el-option v-for="selectedFilter in filter.level.selectedFilters" 
												:key="selectedFilter.value" 
												:label="selectedFilter.text" 
												:value="selectedFilter.value">{{ selectedFilter.text }}</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<el-form :inline="false">
				<el-form-item class="edit-row">
					<div class="edit-name">身份</div>
					<el-select v-if="this.$store.state.isSystemAdminMode"
										 v-model="filter.permission.selected" 
					           placeholder="" 
										 class="filter-select" 
										 @change="permissionSelect">
						<el-option v-for="selectedFilter in filter.permission.selectedAdminFilters" 
											 :key="selectedFilter.value" 
											 :label="selectedFilter.text" 
											 :value="selectedFilter.value">{{ selectedFilter.text }}
						</el-option>
					</el-select>
					<el-select v-else-if="!this.$store.state.isSystemAdminMode && filter.permission.selected !== 2"
					           v-model="filter.permission.selected" 
					           placeholder="" 
										 class="filter-select" 
										 @change="permissionSelect">
						<el-option v-for="selectedFilter in filter.permission.selectedFilters" 
											 :key="selectedFilter.value" 
											 :label="selectedFilter.text" 
											 :value="selectedFilter.value">{{ selectedFilter.text }}
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<el-form :inline="false">
				<el-form-item class="edit-row">
					<div class="edit-name">狀態</div>
					<el-select v-model="filter.status.selected" placeholder="" class="filter-select" @change="statusSelect">
						<el-option v-for="selectedFilter in filter.status.selectedFilters" 
												:key="selectedFilter.value" 
												:label="selectedFilter.text" 
												:value="selectedFilter.value">{{ selectedFilter.text }}</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<el-form :inline="false">
				<el-form-item class="edit-row">
					<div class="edit-name">列入統計</div>
					<el-select v-model="filter.included.selected" placeholder="" class="filter-select" @change="includedSelect">
						<el-option v-for="selectedFilter in filter.included.selectedFilters" 
												:key="selectedFilter.value" 
												:label="selectedFilter.text" 
												:value="selectedFilter.value">{{ selectedFilter.text }}</el-option>
					</el-select>
					<div v-if="filter.included.selected===0" class="included-setting">
						<div v-if="!filter.included.isSetExpiration">
							{{ expirationText }}
							<el-button class="included-btn" @click="setExpiration">
								{{ filter.included.expiration ? '取消期限' : '設定期限' }}
							</el-button>
						</div>
						<div v-if="filter.included.isSetExpiration">
							<el-date-picker
								v-model="filter.included.expiration"
								type="date"
								placeholder="選擇日期"
								:picker-options="filter.included.datePickerOptions">
							</el-date-picker>
							<el-button class="included-btn" @click="confirmExpiration">確定</el-button>
						</div>
					</div>
				</el-form-item>
			</el-form>
		</el-col>

		<hint v-show="hint.display && this.$store.state.hintStatus.edit" :message="hint.message" @close="closeHint"></hint>

	</section>
</template>

<script>
import { DepartmentModel } from '@/common/js/data';
import API from '../../api/api';
	export default {
		data: function ()  {
			return {
				openeye: require('@/assets/icon/ic_eye.png'), 
				nopeneye: require('@/assets/icon/ic_remove_eye.png'),
				showPass: false,
        		showPass2: false,
				show: false,
				accountName: '',
				accountId: '',
				accountEmail: '',
				accountPwd: '',
				checkPwd: '',
				isResetPW: false,
				filter: {
					actualDeps: {
						options: [],
						selected: [],
					},
					level: {
						selectedFilters: [
							{
								value: 0,
								text: 'Level 1 (師2-師5)'
							},
							{
								value: 1,
								text: 'Level 2 (師6-師11)'
							},
							{
								value: 2,
								text: 'Level 3 (師12以上)'
							}
						],
						selected: 0,
					},
					permission: {
						selectedAdminFilters: [
							{
								value: 0,
								text: '一般'
							},
							{
								value: 1,
								text: '部門管理員'
							},
							{
								value: 2,
								text: '系統管理員'
							}
						],
						selectedFilters: [
							{
								value: 0,
								text: '一般'
							},
							{
								value: 1,
								text: '部門管理員'
							}
						],
						selected: 0,
					},
					status: {
						selectedFilters: [
							{
								value: 0,
								text: '停權'
							},
							{
								value: 1,
								text: '開通'
							},
						],
						selected: 1,
					},
					included: {
						selectedFilters: [
							{
								value: 0,
								text: '否'
							},
							{
								value: 1,
								text: '是'
							},
						],
						selected: 1,
						isSetExpiration: false,
						expiration: null,
						datePickerOptions: {
							disabledDate(time) {
								return time.getTime() < Date.now() - 8.64e7;
							}
						},
					}

				},
				//跳出hint
				hint: {
					message: '',
					display: false,
				},
				timer: null,
			}
		},
		computed: {
        	expirationText() {
				if (this.filter.included.expiration) {
					let d = this.filter.included.expiration;
					let dString = d.getFullYear() + '/' + (d.getMonth()+1) + '/' + d.getDate();
					return "直到" + dString;
				}
				return "永不列入統計"
			},
        },
		beforeCreate() {

		},
		created() {	
			this.initial();
		},
		methods: {
			async initial() {
				this.$store.state.nowStatus = 9;
				
				if(!this.$store.state.isBackendMode) {
					this.$router.push({ path: '/table' }); 
					return;
				}

				//get account id
				this.accountId = location.hash.split('/')[2];

				//get getActualDeps
				let departmentModel = new DepartmentModel();
				this.filter.actualDeps.options  = await departmentModel.getActualDepsOptions();
				if(this.accountId) {
					this.$store.state.accountList.status = 3;	
					this.isResetPW = false;
					this.getAccountInfo();
				} else {
					this.isResetPW = true;
					this.$store.state.accountList.status = 2;
					let depId;
					let actual_depid;
					if(!this.$store.state.isSystemAdminMode) {
						depId = this.$store.state.userDepId;
						actual_depid = this.$store.state.userActualDepId;
					} else if (this.$store.state.accountList.selectedDepId.length > 1) {
						depId = this.$store.state.accountList.selectedDepId[0];
						actual_depid = this.$store.state.accountList.selectedDepId[1];
					} else {
						depId = this.filter.actualDeps.options[0].value;
						actual_depid = this.filter.actualDeps.options[0].children[0].value;
					}
					this.initialAccount(null, 
										this.accountId, 
										this.accountEmail, 
										this.accountPwd,
										this.checkPwd, 
										depId,
										actual_depid,
										this.filter.level.selected + 1, 
										this.filter.permission.selected,
										this.filter.status.selected,
										this.filter.included.selected,
										null);
				}
			},
			getAccountInfo() {
				API.accountInfo(this.accountId).then((response) => {
					if(response.status !== 0 && response.status !== 1) {
						redirectLogin(response.data);							
					} else {
						this.initialAccount(response.user.displayname, 
											response.user.username, 
											response.user.email, 
											null, 
											null, 
											response.depId,
											response.actual_depid,
											response.level, 
											response.isManager, 
											response.status,
											response.included,
											response.not_included_date);
					}
				});	
			},
			initialAccount(name, id, email, password, checkPassword, depId , actual_depid, level, isManager, status, included, not_included_date) {
				this.$store.state.editAccount.displayName = name;
				this.$store.state.editAccount.name = id;
				this.$store.state.editAccount.password = password;
				this.$store.state.editAccount.checkPassword = checkPassword;
				this.$store.state.editAccount.email = email;
				this.$store.state.editAccount.isManager = isManager;
				this.$store.state.editAccount.status = status;
				this.$store.state.editAccount.level = level;
				if (actual_depid && (actual_depid != 0)) {
					this.$store.state.editAccount.depId = depId;
					this.$store.state.editAccount.actual_depid = actual_depid;
					this.filter.actualDeps.selected = [depId, actual_depid];
				} else {
					this.$store.state.editAccount.depId = null;
					this.$store.state.editAccount.actual_depid = null;
					this.filter.actualDeps.selected = [];
				}
				this.$store.state.editAccount.included = included;
					
				this.filter.permission.selected = this.$store.state.editAccount.isManager;
				this.filter.level.selected = this.$store.state.editAccount.level - 1;
				this.filter.status.selected = this.$store.state.editAccount.status;
				this.filter.included.selected = this.$store.state.editAccount.included;
				
				if (not_included_date) {
					this.filter.included.expiration = new Date(not_included_date*1000);
					this.$store.state.editAccount.not_included_date = not_included_date;
				} else {
					this.filter.included.expiration = null;
					this.$store.state.editAccount.not_included_date = 0;
				}
				
				this.show = true;
			},
			actualDepsSelect: function(key) {
				this.$store.state.editAccount.depId = key[0];
				this.$store.state.editAccount.actual_depid = key[1];
			},
			levelSelect: function(key) {
				this.$store.state.editAccount.level = key + 1;
			},
			permissionSelect: function(key) {
				this.$store.state.editAccount.isManager = key;	
			},
			statusSelect: function(key) {
				this.$store.state.editAccount.status = key;
			},
			prevent: function(e) {
				if(e.keyCode === 13) {
					e.preventDefault();
				}
			},
			/**
			  * resetPassword 重設密碼
				* @param  {bool} reset - 是否重設密碼
			  * @return none
    		*/
			resetPassword: function() {
				this.$store.state.editAccount.password = '';	
				this.$store.state.editAccount.checkPassword = '';
				this.isResetPW = true;
			},
      		/**
			  * closeHint close hint 視窗
			  * @return none
			  */
			closeHint: function() {
				this.hint.display = false;
				this.$store.state.hintStatus.editAccount = false;
				clearTimeout(this.timer);
			},
			/**
			  * showHint 
			  * @param  {string} message - message
			  * @return none
			  */
			showHint: function(message) {
				if(this.timer) {
					clearTimeout(this.timer);	
				}
				this.hint.display = true;
				this.hint.message = message;	
				this.$store.state.showHint = true;
				this.$store.state.hintStatus.editAccount = true;
				this.timer = setTimeout(()=>{
					if(this.$store.state.showHint) {
						this.$store.state.showHint = false;
						this.$store.state.hintStatus.editAccount = false;
					}
				}, this.$store.state.fadeOutTime);
			},
			includedSelect(key) {
				this.$store.state.editAccount.included = key;
				if (key === 1) {
					this.clearExpiration();
				}
			},
			setExpiration() {
				if (this.filter.included.expiration) {
					this.clearExpiration();
				} else {
					this.filter.included.isSetExpiration = true;
				}
			},
			clearExpiration() {
				this.filter.included.expiration = null;
				this.$store.state.editAccount.not_included_date = 0;
			},
			confirmExpiration() {
				this.filter.included.isSetExpiration = false;
				if (this.filter.included.expiration) {
					this.$store.state.editAccount.not_included_date = this.filter.included.expiration.setHours(23,59,59)/1000;
				} else {
					this.$store.state.editAccount.not_included_date = 0;
				}
			},
		},
		mounted() {
			
		}
	}
</script>

<style lang="scss">
$font-color: #222222;
$tag-color: #626874;
$border-color: #D5D5D4;
$button-color: #2E90F4;

.edit-table {
	margin-top: 8px;
	position: relative;
	left:25%;
	.edit-row {
		padding-bottom: 15px;	
		border-bottom: 1px solid $border-color;
		.edit-name {
			color: $font-color;
			font-size: 16px;
			line-height: 36px;
			font-weight: 700;
			float: left;
		}
		.edit-input {
			background-color: white;
			border-radius: 2px;
			border: 1px solid $border-color;
			height: 36px;
			width: 18vw;
			margin-left: 50px;
			font-size: 14px;
			padding-left: 10px;
		}
		.check-input {
			background-color: white;
			border-radius: 2px;
			border: 1px solid $border-color;
			margin-top: 10px;
			height: 36px;
			width: 18vw;
			font-size: 14px;
			padding-left: 10px;
		}
		.reset-btn {
			display: inline-block;
			background: white;
			border-radius: 2px;
			color: $button-color;
			font-size: 14px;
			height: 36px;
			margin-left: 50px;
			border: 1px solid $button-color;
			width: 92px;
		}	
		.filter-select {
			display: block;
			max-width: 18vw;
			text-align: center;
			margin-left: 82px;
			.el-input__inner {
				border-color: $border-color;
				background-color: white;
				border-radius: 2px;
				font-size: 14px;
				color: $font-color;
				line-height: 24px;
					
			}
			.el-input__icon {
				width: 40px;
				color: $tag-color;
			}
			.el-input__suffix {
				&:before{
					content: '';
					position: absolute;
					left: 0;
					height: 32px;
					width: 1px;
					background-color: rgba(151, 151, 151, .35);
					margin-top: 7px;
				}
			}
			.el-icon-arrow-up {
				&:before {
					color: #a7a7a7;
					content: '\25B2';
				}
			}
		}
		.included-setting {
			margin-top: 11px;
			margin-left: 98px;
			height: 30px;
			color: #515151;
			font-size: 14px;
			line-height: 24px;

			.included-btn {
				margin-left: 10px;
				text-align: center;

				width: 90px;
				border: 1px solid #CACACA;
				border-radius: 2px;
				background-color: #E7E7E7;
				color: #515151;
			}	
		}

	}
}
</style>


// WEBPACK FOOTER //
// EditAccount.vue?8908fcaa